import React, { Component } from "react";
import { connect } from 'react-redux';

import NotebookData from '../../../../data/notebook.json'

import {
    showModal,
} from 'actions';

import "./ProtocolRead.scss";
import colors from 'styles/_exports.module.scss';
import IconStart from 'components/icons/start-solid';

import { withTranslation } from 'react-i18next'

class ProtocolRead extends Component {
    constructor(props) {
        super(props);

        this.state = {
        }
    }

    save = () => {
      this.props.showModal(false)
    }

    render() {

        return (
            <div className="modal-section level-choice">
              <div className="modal-header">
                  <h2 tabIndex="0">{this.props.t("READ THROUGH THE PROTOCOL")}</h2>
              </div>
              <ol style={{padding: '0 0 0 16px'}}>
                {NotebookData.Notebook.Content.Protocol.Sequence.map(step =>{
                    return(
                      <li style={{marginBottom: '16px'}} tabIndex={0}>{this.props.t(step.label)}</li>
                    )
                 })}
              </ol>
              <div className="modal-footer lvl-choice">
                  <button
                    aria-label={this.props.t("Start simulation button")}
                    tabIndex={this.props.tab} className="modal-btn-primary lvl-choice" onClick={this.save}>
                    <IconStart style={{ color: colors.charcoal1, height: "16px", top: "2px"}}/>
                      {this.props.t("Start simulation")}
                  </button>
              </div>
            </div>
        );
    }
}

const mapStateToProps = () => {
  return {
  }
}

export default connect(mapStateToProps, {
    showModal,
})(withTranslation()(ProtocolRead));
